module.exports = __webpack_public_path__ + "media/images/error/404-33e1ca1df61f5ac4ee71820cb207a5db.svg";